import { render, staticRenderFns } from "./promoterIndex.vue?vue&type=template&id=31a54256&scoped=true"
import script from "./promoterIndex.vue?vue&type=script&lang=js"
export * from "./promoterIndex.vue?vue&type=script&lang=js"
import style0 from "./promoterIndex.vue?vue&type=style&index=0&id=31a54256&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a54256",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31a54256')) {
      api.createRecord('31a54256', component.options)
    } else {
      api.reload('31a54256', component.options)
    }
    module.hot.accept("./promoterIndex.vue?vue&type=template&id=31a54256&scoped=true", function () {
      api.rerender('31a54256', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/promoterIndex.vue"
export default component.exports